import React, { useState } from "react";
import "../RatingModal.css";

const StarRating = ({ rating, maxStars = 5, interactive = false, onRatingChange }) => {
  const [hoverRating, setHoverRating] = useState(0);

  return (
    <div className="star-rating-container">
      {Array.from({ length: maxStars }, (_, index) => {
        const starValue = index + 1;
        const isActive = starValue <= (interactive && hoverRating ? hoverRating : rating);

        return (
          <span
            key={index}
            className={`star ${isActive ? "star-active" : "star-inactive"} ${interactive ? "star-interactive" : ""}`}
            onClick={() => interactive && onRatingChange && onRatingChange(starValue)}
            onMouseEnter={() => interactive && setHoverRating(starValue)}
            onMouseLeave={() => interactive && setHoverRating(0)}
          >
            ★
          </span>
        );
      })}
    </div>
  );
};

export default StarRating;